import { ApiRequest } from "src/models/api.request";
import GnlParametreDTO from "src/models/GnlParametre/GnlparametreDTO";
import api from "src/services/core/api";

const controllerName = "GnlParametreDTO";

export const parametersApi = api.injectEndpoints({
    endpoints: builder => ({
        getAllParameters: builder.query<Array<GnlParametreDTO>, void>({
            query: () => {
                let apiReq:ApiRequest<GnlParametreDTO> = {
                    sorts: [{ fieldName: "sirano" }],
                }
                return {
                    url: controllerName + "/find",
                    method: "POST",
                    body: apiReq
                }
            },
            providesTags:["Parameters"]
        })
    }),
})

export const { useGetAllParametersQuery } = parametersApi;